import React from "react";
import { BsChevronDown } from "react-icons/bs";
import { daysOfWeek } from "../../../logic/calendarSettings";
import { set } from "../../../redux/features/settings/settingsSlice";
import { useDispatch, useSelector } from "react-redux/es";
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import { languages } from "../../languages";

const BussinessDays = ({ tabID }) => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.app);
  const currentLang = useSelector((state) => state.settings.language);

  const boundRef = React.useRef(null);
  const pickerRef = React.useRef(null);

  const [isFocused, setIsFocused] = React.useState(false);
  const [openPicker, setOpenPicker] = React.useState(false);
  const [value, setValue] = React.useState(settings.calendarBussinesDays ?? "");
  const [selectedRow, setSelectedRow] = React.useState(settings.calendarBussinesDays ?? "");

  React.useEffect(() => {
    setValue(settings.calendarBussinesDays ?? "");
  }, [tabID]);

  React.useEffect(() => {
    if (openPicker) {
      const clickListener = (e) => {
        const click = pickerRef.current.contains(e.target) || boundRef.current.contains(e.target);
        if (!click) {
          setIsFocused(false);
          setOpenPicker(false);
        }
      };
      document.addEventListener("mousedown", clickListener);
      return () => document.removeEventListener("mousedown", clickListener);
    }
  }, [openPicker]);

  const handlePicker = (e) => {
    e.stopPropagation();
    setOpenPicker((x) => !x);
    setIsFocused((x) => !x);
  };

  const handleClickOnRow = (key) => {
    const SelectedArray = selectedRow.split(",");
    if (SelectedArray.indexOf(key) >= 0) {
      SelectedArray.splice(SelectedArray.indexOf(key), 1);
    } else {
      SelectedArray.push(key);
    }
    setSelectedRow(SelectedArray.filter((x) => x != "").join(","));
    setValue(SelectedArray.filter((x) => x != "").join(","));
    dispatch(set({ key: "calendarBussinesDays", value: SelectedArray.filter((x) => x != "").join(",") }));
  };
  return (
    <div className="s1-calendarBussinesDays w-100" style={{ flex: `100%` }}>
      <InputGroup ref={boundRef} className={`crm-floating-with-icon${isFocused ? " underline-focus" : ""}`}>
        <FloatingLabel
          controlId="calendarBussinesDays"
          label={languages.settings[currentLang].calendarBussinesDays}
          style={{ whiteSpace: "nowrap" }}
          className="w-100"
        >
          <Form.Control
            className="d-flex w-100 ps-1 border-0"
            readOnly={true}
            value={value}
            name="calendarBussinesDays"
            placeholder={languages.settings[currentLang].calendarBussinesDays}
            onClick={handlePicker}
            onFocus={(e) => e.target.blur()}
          />
        </FloatingLabel>
      </InputGroup>
      {openPicker && (
        <div
          className="input-picker-div custom"
          ref={pickerRef}
          style={{
            left: boundRef.current.getBoundingClientRect().left,
            width: boundRef.current.getBoundingClientRect().width,
            top:
              boundRef.current.getBoundingClientRect().bottom -
              (boundRef.current.getBoundingClientRect().bottom + 200 > window.innerHeight
                ? 200 + boundRef.current.getBoundingClientRect().height
                : 0),
            height: "200px",
            overflow: "auto",
          }}
        >
          <div className="input-picker-table w-100">
            {Object.keys(daysOfWeek[currentLang]).map((key) => {
              return (
                <div
                  key={key}
                  className={`input-picker-table-row${
                    selectedRow.split(",").indexOf(key) >= 0 ? " input-picker-table-row-selected" : ""
                  }`}
                  onClick={() => handleClickOnRow(key)}
                >
                  <span>{daysOfWeek[currentLang][key]}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default BussinessDays;
